define('webshopProductsListOutdatedView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'checkboxView',
  'tableFieldView',
  'template!webshopProductsListOutdatedView',
  'entities/webshop/products'
], function (
  App,
  Module,
  Backbone,
  _,
  Settings,
  CheckboxView,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'webshop-products-list-outdated-view ' + FieldView.prototype.className,

    regions: {
      'checkboxRegion': '.checkbox-region'
    },

    modelEvents: {
      'change:outdated': 'render'
    },

    onRender: function () {
      this.checkboxView = new CheckboxView({
        title: _.i18n('webshop.product.outdated.title'),
        text: _.i18n('webshop.product.outdated'),
        value: this.model.getOutdated(),
        onChange: _.bind(function (value) {
          var defer = $.Deferred();
          this.model.setOutdated(value).done(_.bind(function () {
            this.model.fetch().done(_.bind(function () {
              this.checkboxView.setValue(this.model.getOutdated());
              defer.resolve();
            }, this));
          }, this)).fail(_.bind(function () {
            this.model.fetch();
            defer.reject();
          }, this));
          return defer.promise();
        }, this)
      });
      this.checkboxRegion.show(this.checkboxView);
    }
  });
});
